import { Dispatch, SetStateAction } from "react";

import { Tag, TagResponse } from "@/generated";
import { useSpotUser } from "@/utils/spotUser";
import { FlowTagModal } from "./FlowTagModal";
import { useTagMutations } from "./useTagMutations";
import { DeleteDialog } from "../Modals/DeleteDialog";

export type TagAction = {
  type: "edit" | "delete";
  tag: Tag | TagResponse;
};

export function FlowTagActionsDialog({
  action,
  setAction,
  onDeleted,
}: {
  action: TagAction | undefined;
  setAction: Dispatch<SetStateAction<TagAction | undefined>>;
  onDeleted: (tagId: string) => void;
}) {
  const { spotGroup } = useSpotUser();
  const { editTag, deleteTag } = useTagMutations({});

  if (!action) return null;

  const { tag } = action;
  const close = () =>
    setAction((current) => (current === action ? undefined : current));
  const path = { group_id: spotGroup.id, tag_id: tag.id };
  const handleOpenChange = (open: boolean) => {
    if (!open) close();
  };

  return action.type === "edit" ? (
    <FlowTagModal
      key={tag.id}
      isOpen
      isEdit
      tag={tag}
      onOpenChange={handleOpenChange}
      onConfirm={(values) =>
        editTag.mutate({ path, body: values }, { onSettled: close })
      }
    />
  ) : (
    <DeleteDialog
      isOpen
      title="Delete tag"
      text="Are you sure you want to delete this tag?"
      cancelLabel="Cancel"
      confirmLabel="Delete"
      isLoading={deleteTag.isPending}
      onOpenChange={handleOpenChange}
      onDelete={() => {
        if (deleteTag.isPending) return;
        deleteTag.mutate(
          { path },
          {
            onSuccess: () => onDeleted(tag.id),
            onSettled: close,
          }
        );
      }}
    />
  );
}
